import React from 'react'
import { connect } from 'react-redux';
import { Card, CardBlock, CardTitle , Button , Input , FormGroup, Label} from 'reactstrap';

import ReactTable from "react-table";
import "react-table/react-table.css";

import * as actions from  '../../../actions/factura';
import {api} from '../../../actions/_request';

import _ from "lodash";
import Select from 'react-select';

import moment from 'moment';

import Menu from '../menu.js';
import ModalTablas from '../../../components/catalogos/modal_tablas.js'
import FacturaModal from './invoiceProductos.js'

import IconEdit from 'react-icons/lib/md/edit'
import IconList from 'react-icons/lib/fa/list-alt'
import IconHistorico from 'react-icons/lib/fa/archive'
import IconPlus from 'react-icons/lib/fa/plus'
import FAchevronleft from 'react-icons/lib/fa/chevron-left';
import Refresh from 'react-icons/lib/fa/refresh';


// react-icons/lib/fa/refresh

import swal from 'sweetalert2';
const filterCaseInsensitive = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null){
                return (
                    row[id] !== undefined ?
                        String((row[id]+'').toLowerCase()).includes(filter.value.toLowerCase())
                        :
                        true
                );
            }
        };
const tipos_precios = [
  {label: 'Contado', value: 0},
  {label: 'Credito', value: 1}, 
];
const tipos_compra = [
  {label: 'Normal', value: 0},
  {label: 'Proyectos', value: 1}, 
];

class InvoiceModuleForm extends React.Component{
	constructor(props){
		super(props)

		this.state = {
			factura : {
				factura_consecutivo : '',
				concepto : '',
				fecha : moment().format('Y-MM-DD'),
				tc : '',
				moneda: 'MXN',
				cliente_id : '',
				vendedor_id : '',
				almacen_codigo : '',
				comision : '',
				facturar_a : '',
				direccion : '',
				no_guia : '',
				lab_id : '',
				lab_codigo : '',
				notasHeader : '',
				plazo_p : '',
				modalProducto : false,
				tipo_doc : '1',
                exportacion:'01',
        importe : 0,
        descuentos : 0,
        subtotal : 0,
        ieps : 0,
        total : 0,
        impuestos : 0,
        impuesto1_prod : 0,
        impuesto2_prod : 0,
        saldo : 0,
        credito_disponible : 0,
        credito:1,
        tipo_venta:0,
			},
			productos : [],
      tickets: [],
			folios : [],
			modal : false,
      action:'save',
      indiceproducto : null,
      prospectoid : null,
      producto_renglon:[],
      motivos:[     {label:'[01] Nota de crédito de los documentos relacionados',value:'01'},
                     {label:'[02] Nota de débito de los documentos relacionados',value:'02'},
                     {label:'[03] Devolución de mercancía sobre facturas o traslados previos',value:'03'},
                     {label:'[04] Sustitución de los CFDI previos',value:'04'},
                     {label:'[05] Traslados de mercancias facturados previamente',value:'05'},
                     {label:'[06] Factura generada por los traslados previos',value:'06'},
                     {label:'[07] CFDI por aplicación de anticipo',value:'07'},
                     {label:'[08] Factura generada por pagos en parcialidades',value:'08'},
                     {label:'[09] Factura generada por pagos diferidos',value:'09'},
              ],
		}
		this.handleInputChange = this.handleInputChange.bind(this); 
		this.toggle_modal= this.toggle_modal.bind(this);   
    this.retorno= this.retorno.bind(this);  
    this.ChangeCode= this.ChangeCode.bind(this);
    this.handleClose= this.handleClose.bind(this);
    this.handleRadioChange = this.handleRadioChange.bind(this);
    this.toggleProducto = this.toggleProducto.bind(this);
    this.retornoProducto = this.retornoProducto.bind(this);
    this.handleSelectChange= this.handleSelectChange.bind(this);
    this.delete = this.delete.bind(this);
    this.submit = this.submit.bind(this);
    this.actualizar_tc = this.actualizar_tc.bind(this);
    this.delete_ticket = this.delete_ticket.bind(this);
	}
 actualizar_tc(){
  let {factura} = this.state;
  let self = this;
  api().get('/tipo_cambio_venta')
        .then(function(response)
        {             
          // console.log(response)     
            if(response.status === 200)
            { 
              factura.tc = parseFloat(response.data.venta);
               self.setState({
                  factura : factura,
               })
            }

        });
 }
	
	componentDidMount() {
		let self = this;
		let {factura} = self.state;
    const {params} = this.props.match;
    let user= this.props.auth.user;
    console.log('usuario', user);
// factura_consecutivo
      api().get('/formulario_factura')
      .then(function(response)
      {
        if(response.status === 200)
        {
          factura.almacen_codigo=response.data.almacen.codigo;
          factura.almacen_nombre=response.data.almacen.nombre;
          factura.almacen_id=response.data.almacen.id;
          factura.tc=response.data.cambio;
          factura.vendedor_id = user.id;
          factura.vendedor_nombre = user.name;
          factura.comision = 0.00;
          self.setState({
            formas : response.data.formas,
            metodos : response.data.metodos,
            usos : response.data.usos,
            factura:factura,
          });
          if(params.id){
          api().get('/searchInvoice/'+params.id).then((response) => {
           // console.log('factura---->',response.data);
            self.setState({
              factura: response.data.factura,
              productos:response.data.productos,
              action:'update',
            });
            self.calcular_totales(response.data.productos,response.data.factura);
          });
        }
        }
      });			
    }

    handleSelectChange(select, name,tipo=0) {
    	let {factura} = this.state;
      let value=null;
        if(tipo==0){
           value = select === null ? null : select.target.value;
        }else{
           value = select === null ? null : select.value;
        }
		    factura[name] = value;
        this.setState({factura : factura});
    }


	handleInputChange(event) {
        let {factura} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        factura[name] = value;
        this.setState({
            factura : factura
        });
    }
    handleClose (event) {
     
        let {producto} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        let campo="";
        let tabla=""

         switch (name) {
            case "cliente_id":                  
                campo = "cliente_id";
                tabla="/busqueda_cliente/"+this.state.factura.cliente_id;
                break;
            case "vendedor_id":                  
	            campo = "vendedor_id";
	            tabla="/busqueda_usuario/"+this.state.factura.vendedor_id;
	            break;   
	        case "almacen_codigo":                  
	            campo = "almacen_codigo";
	            tabla="/busqueda_almacen/"+this.state.factura.almacen_codigo;
	            break;
	        case "embarque_id":
	        	campo = "embarque_id";
	        	tabla = "/embarque/"+this.state.factura.embarque_id;
	        	break;
	       	case "lab_codigo":
	       		campo = "lab_id";
	       		tabla = "/lab/"+this.state.factura.lab_codigo;
	       		break;
	       	case "term_pago":
	       		campo = "term_pago";
	       		tabla = "/terminos_pago/"+this.state.factura.term_pago;
	       		break;
        }
        let self =this;
        if(value!=""){
            api().get(`${tabla}`)
            .then(function(response)
            {             
            	// console.log(response)     
                if(response.status === 200)
                { 
                    let vaciar=0;
                     if(Object.keys(response.data).length > 0){
                        let  retorno=response.data;
                        self.retorno(retorno,campo,vaciar,value);
                     }  else{
                         vaciar=1
                         swal("Oops..", "No Existe el Codigo");
                          self.retorno(response.data,campo,vaciar,value);
                     }        
                }
            });
        }else{
            self.retorno([],campo,1,value); 
        }
   }

    ChangeCode(event) {
        let {inventarioFisico} = this.state;
        const target    = event.target;
        let value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        if(target.type === 'checkbox'){
            value='0';
            if(target.checked)
                value='1';
        }
        inventarioFisico[name]=value;
        
            this.setState({
            	inventarioFisico :inventarioFisico
           });   
    }

    handleRadioChange(event) {
    	let {factura} = this.state;
    	factura['moneda']= event.target.value
		this.setState({
	    	factura : factura
	   	});
	}

    retorno(objeto,campo,vacio=0,valor=""){
       	// console.log('renglon---->',objeto);
        let {factura} = this.state;
        let self =this;
        let bandera=0;
   console.log('retorno campo---->',campo)
        switch (campo) {
            case "cliente_id":
                  factura[campo] = objeto.item_id?objeto.item_id:objeto.value;
                  factura.cliente_nombre=objeto.label?objeto.label:objeto.nombre;
                  factura.facturar_a = objeto.rSocial;
                  factura.direccion = objeto.domicilio;
                  factura.rfc = objeto.rfc;
                  factura.ciudad = objeto.ciudad;
                  factura.term_pago = objeto.term_pago;
                  factura.term_pago_nombre = objeto.term_pago_nombre;
                  // factura.vendedor_id = objeto.vendedor?objeto.vendedor.id:'';
                  // factura.vendedor_nombre = objeto.vendedor?objeto.vendedor.name : '';
                  // factura.comision = objeto.comision;
                  factura.codigo_comision = objeto.codigo_comision;
                  factura.plazo_p = objeto.plazo_credito;
                  factura.descuento = objeto.descuento;
                  factura.codigo_precio = objeto.codigo_precio;
                  factura.embarque_id = objeto.embarque_id;
                  factura.embarque_nombre = objeto.embarque_nombre;
                  factura.lab_id = objeto.lab_id;
                  factura.lab_nombre = objeto.lab_nombre;
                  factura.saldo_cliente = objeto.saldo;
                  factura.credito_disponible = objeto.credito_disponible;
                  factura.recidencia_fiscal = objeto.codigo_pais;
                  factura.registro_fiscal = objeto.registro_fiscal;
                  factura.uso_cfdi = objeto.uso_cfdi;
                  factura.formas_pago_codigo = objeto.forma_pago;
                  factura.metodo_pago_codigo = objeto.metodo_pago;
                  factura.codigo_postal = objeto.codigo_postal;
                  factura.regimen = objeto.regimen_id;
                  break;
            case "vendedor_id":
                  factura[campo] = objeto.value;
                  factura.vendedor_nombre=objeto.label?objeto.label:objeto.nombre;
                  break;
            case "almacen_codigo":
              factura.almacen_codigo = objeto.codigo;
            	factura.almacen_id = objeto.value;
            	factura.almacen_nombre = objeto.label?objeto.label:objeto.nombre;
            	break;
           	case "embarque_id":
           		factura.embarque_nombre = objeto.label?objeto.label:objeto.nombre;;
           		break;
           	case "lab_id":
           		factura.lab_nombre = objeto.label?objeto.label:objeto.nombre;
              factura.lab_id = objeto.item_id?objeto.item_id:objeto.value;
           		break;
           	case "term_pago":
           		factura[campo] = objeto.label?objeto.label:objeto.nombre;
           		break;
            case'factura_imp':
              self.importar_productos(0,objeto.productos);
              bandera=1;
              break;
            case'ticket_imp':
              self.importar_productos(1,objeto.productos);
              bandera=1;
              break;
               case'folio_relacion':
              self.folio_relacion(objeto);
            
              break;

        }  
       if(vacio==1){
        console.log('vaciar')
        if(campo == 'cliente_id')
        	factura.cliente_id='';
        else if(campo == 'vendedor_id'){
        	factura.vendedor_id='';
        }
        else if(campo == 'almacen_codigo'){
        	factura.almacen_codigo = '';
        }
        else if(campo == 'term_pago'){
          console.log('term_pago')
        
         factura.term_pago = 0;
         factura.term_pago_nombre='';
        }
        else if(campo == 'embarque_id'){
          console.log('embarque_id')
        
         factura.embarque_id = 0;
         factura.embarque_nombre='';
        }else if(campo == 'lab_id'){
          console.log('lab_id')
        
         factura.lab_id = 0;
         factura.lab_nombre='';
        }

        //factura[campo] =0;
       }

       if(bandera==0){
        self.setState({
            factura : factura,           
            modal:false,         
        })
       }else{
        self.setState({     
            modal:false,         
        })
       }
    }
    
    toggle(){
    }

    delete(evt,index){
    	let {productos, factura} = this.state;   
      let renglon=productos[index];

      if( parseInt(renglon.ticket_id)>0){
          for (var i = productos.length - 1; i >= 0; i--) {
            if(parseInt(renglon.ticket_id)==parseInt(productos[i].ticket_id))
            productos.splice(i,1);
          }
      }else{
        productos.splice(index,1);
      }  
    	this.calcular_totales(productos,factura);
    }

    delete_ticket(evt,renglon){
      console.log('delete ticket');
      console.log('ticket--->',renglon);

      let {productos, factura} = this.state;   
          for (var i = productos.length - 1; i >= 0; i--) {
            if(parseInt(renglon.id)==parseInt(productos[i].ticket_id))
            productos.splice(i,1);
          }
      this.calcular_totales(productos,factura);
    }

    toggleProducto(evt,item_id=null,indice=null,producto=[]){
    let {modalProducto} = this.state;

    this.setState({
      modalProducto : !modalProducto,
       indiceproducto : indice,
        prospectoid : item_id,
        producto_renglon:producto,
    })
  }

    toggle_modal(index=0,catalogo="",campo=""){  

        this.setState({
            modal : !this.state.modal,
            titulo:catalogo,
            tabla_modal:index,
            campo_modal:campo,         
        })
    }
    trunc (sVal, nDec = 0) {
      // var s = x.toString()
      // var l = s.length
      // var decimalLength = s.indexOf('.') + 1
      // var numStr = s.substr(0, decimalLength + posiciones)
      // return Number(numStr)


        var n = parseFloat(sVal); 
        var s = "0.00"; 
        if (!isNaN(n)){ 
         n = Math.round(n * Math.pow(10, nDec)) / Math.pow(10, nDec); 
         s = String(n); 
         s += (s.indexOf(".") == -1? ".": "") + String(Math.pow(10, nDec)).substr(1); 
         s = s.substr(0, s.indexOf(".") + nDec + 1); 
        } 
        return s; 
    }

        formateo(value) {
      let etiqueta='$';

      var decimals =  2;
      var  separators =[',', ",", '.'];
      var number = (parseFloat(value) || 0).toFixed(decimals);
      if(number<0)
        etiqueta='$ -';

      if (number.length <= (4 + decimals))
      return etiqueta +number.replace('.', separators[separators.length - 1]);
      var parts = number.split(/[-.]/);
      value = parts[parts.length > 1 ? parts.length - 2 : 0];
      var result = value.substr(value.length - 3, 3) + (parts.length > 1 ?
      separators[separators.length - 1] + parts[parts.length - 1] : '');
      var start = value.length - 6;
      var idx = 0;
      while (start > -3) {
      result = (start > 0 ? value.substr(start, 3) : value.substr(0, 3 + start))
      + separators[idx] + result;
      idx = (++idx) % 2;
      start -= 3;
      }
      return etiqueta + result;
    }

    retornoProducto(obj){
    	let {productos} = this.state;
      let {factura} = this.state;
       var indiceproducto= this.state.indiceproducto;
       console.log('retorno producto---->',obj);
       // console.log('indice--->',indiceproducto)
      if(indiceproducto==null){
       productos.push(obj);
      }else{
        productos[indiceproducto]=obj;
      }
      this.calcular_totales(productos,factura);
    }
    calcular_totales(productos,factura){
      let importe=0;
      let descuentos=0;
      let subtotal=0;
      let ieps=0;
      let impuestos=0;
      let total=0;
      let tickets=[];
      let bandera=true;

      for (var i = productos.length - 1; i >= 0; i--) {
        bandera=true;
        importe+=parseFloat( productos[i].importe);
        descuentos+=parseFloat( productos[i].descuento);
        subtotal+=(parseFloat( productos[i].importe)-parseFloat( productos[i].descuento));
        // impuestos+=(parseFloat( productos[i].impuesto1)+parseFloat( productos[i].impuesto2));
        if(productos[i].tipo_impuesto1=="Traslado"){impuestos+=productos[i].impuesto1}else{impuestos-=productos[i].impuesto1}
        if(productos[i].tipo_impuesto2=="Traslado"){impuestos+=productos[i].impuesto2}else{impuestos-=productos[i].impuesto2}


        ieps+=parseFloat( productos[i].ieps_venta);
        total+=parseFloat( productos[i].total);

        if(parseInt( productos[i].ticket_id)>0)
        {  
          for (var x = tickets.length - 1; x >= 0; x--) {

           if( parseInt( tickets[x].id) == parseInt( productos[i].ticket_id) )
           {
            bandera=false;
            break;
           }
          }
          if(bandera){
            tickets.push({
             id: productos[i].ticket_id,
             clave:  productos[i].clave_ticket,
            });
          }
        }
      }

      factura.importe = this.trunc(importe,2);
      factura.descuentos = this.trunc(descuentos,2);
      factura.subtotal = this.trunc(subtotal,2);
      factura.ieps = this.trunc(ieps,2);
      factura.impuestos = this.trunc(impuestos,2);
      factura.total = this.trunc(total,2);
      // console.log('lista tickets----->',tickets);
      this.setState({
            productos:productos,
            factura:factura, 
            tickets: tickets,        
        })
    }
    folio_relacion=(data)=>{
        let _self = this;

      let{factura} = this.state;

        api().get(`/get_folio_factura/${data.value}`)
            .then(function(response)
            {             
                // console.log(response)     
                if(response.status === 200)
                { 
                    factura.folio_relacion=response.data.folio;
                    _self.setState({
                        
                        factura:factura, 
                            
                    })      
                }
            });





    }
    importar_productos(tipo,importacion){
      // console.log('productos a importar-->', importacion)
      let {productos} = this.state;
      let {factura} = this.state;
       for (var i = importacion.length - 1; i >= 0; i--) {
        if(tipo==0){
          //productos que vienen de una factura o cotizacion
          console.log('producto---->',importacion[i]);
          /*tenemos que quitar el id del productos , la factura_id, el ticker_id, */
          importacion[i].id=null;
          importacion[i].factura_id=null;
          importacion[i].ticket_id=0;
          importacion[i].clave_ticket='';

          productos.push(importacion[i]);
        }else{
          console.log('articulo '+i+'----------->',importacion[i])
          let tem=importacion[i];
          let tempCantidad = parseFloat(tem.cantidad);
          let tempPrecio = parseFloat(tem.precio);
          let tempDescuento = parseFloat(tem.descuento_porc);
          let tempieps = parseFloat(tem.ieps_venta_porc);
          let tempImpto1 = parseFloat(tem.impuesto1_porc);
          let tempImpto2 = parseFloat(tem.impuesto2_porc);

          let tempImporte = tempCantidad * tempPrecio;

          let descuentoItem = (tempImporte * tempDescuento / 100);
          let subTotal = tempImporte - descuentoItem;

          let iepsItem = subTotal * tempieps / 100; 

          let subIeps = subTotal+ iepsItem;

          let tempimpuesto1 = subIeps * tempImpto1 / 100;
          let tempimpuesto2 = subIeps * tempImpto2 / 100;

          let tempImpuestos=0;
         // tempimpuesto1 + tempimpuesto2;
        if(importacion[i].tipo_impuesto1=="Traslado"){tempImpuestos+=tempimpuesto1}else{tempImpuestos-=tempimpuesto1}
        if(importacion[i].tipo_impuesto2=="Traslado"){tempImpuestos+=tempimpuesto2}else{tempImpuestos-=tempimpuesto2}

          let tempTotal = subTotal + iepsItem + tempImpuestos;


          tem.importe = this.trunc(tempImporte,2);
          tem.descuento = this.trunc(descuentoItem,2);
          tem.subtotal = this.trunc(subTotal,2);
          tem.ieps_venta = this.trunc(iepsItem,2);
          tem.impuestos = this.trunc(tempImpuestos,2);
          tem.impuesto1 = this.trunc(tempimpuesto1,2);
          tem.impuesto2 = this.trunc(tempimpuesto2,2);
          tem.total = this.trunc(tempTotal,2);

          // console.log('importe--->',tempImporte);
          // console.log('subtotal --->',subTotal);
          // console.log('ieps --->',iepsItem);
          // console.log('impuestos ---> ',tempImpuestos);
          // console.log('producto --->',tem);

          productos.push(tem);
        }
      }
      this.calcular_totales(productos,factura);

    }

    submit(evt){
      evt.preventDefault();
      let self = this;

      let{factura} = this.state;

      let{productos,action,tickets} = this.state;

      var newarray = [];
      let descripcion='';
      let save=true;

      if(factura.codigo_postal==null){

      }

      productos.some(function(obj) {

         // console.log('producto--->',obj);
         // console.log('ieps-->',obj.ieps);

         if(parseInt(obj.unidad_sat_id)==0||obj.unidad_sat_nombre==''||obj.unidad_sat_codigo==''){
          save=false;
          descripcion='Datos Faltantes en el Producto '+obj.descripcion_item;
         }

         if(parseInt(obj.prod_serv_id)==0||obj.prod_serv_codigo==''){
          save=false;
          descripcion='Datos Faltantes en el Producto '+obj.descripcion_item;
         }

        newarray.push({
          id : obj.id,
          item_id : obj.item_id,
          codigo_item: obj.codigo_item,
          descripcion_item : obj.descripcion_item,
          unidad_sat_codigo : obj.unidad_sat_codigo,
          unidad_sat_id : obj.unidad_sat_id,
          unidad_sat_nombre: obj.unidad_sat_nombre,
          ud_venta : obj.unidad_venta,
          cantidad : obj.cantidad,
          precio : obj.precio,
          descuento : obj.descuento,
          descuento_porc : obj.descuento_porc,
          importe : obj.importe,
          impuesto1: obj.impuesto1,
          impuesto1_porc: obj.impuesto1_porc, 
          tipo_impuesto1: obj.tipo_impuesto1,
          factor_impuesto1: obj.factor_impuesto1,
          codigo_sat_impuesto1: obj.codigo_sat_impuesto1,
          impuesto2: obj.impuesto2,
          impuesto2_porc : obj.impuesto2_porc,
          tipo_impuesto2: obj.tipo_impuesto2,
          factor_impuesto2: obj.factor_impuesto2,
          codigo_sat_impuesto2: obj.codigo_sat_impuesto2,
          ieps_venta: obj.ieps_venta,
          ieps_venta_porc : obj.ieps_venta_porc,
          tipo_ieps: obj.tipo_ieps,
          factor_ieps: obj.factor_ieps,
          codigo_sat_ieps: obj.codigo_sat_ieps,
          total : obj.total,
          utilidad : 0,
          comision: 0,
          comision_porc : obj.comision,
          prod_serv_id : obj.prod_serv_id,
          prod_serv_codigo : obj.prod_serv_codigo,
          nota : '',
          clave_ticket : obj.clave_ticket,
          ticket_id : obj.ticket_id,
          combo_id : obj.combo_id,
          combo : obj.combo,

        });

      });
      
      console.log( 'productos---->',newarray)
      if(newarray.length>0){

     

      factura.items = newarray;
      factura.tickets = tickets;

      if(action=='save'){
        factura.saldo = factura.total;
        factura.saldo_impuesto = factura.impuestos;
        factura.saldo_subtotal = parseFloat(factura.subtotal)+parseFloat(factura.ieps);
      }

      if(factura.tipo_doc == '1')
        factura.concepto = 'FACTURA';
      else
        factura.concepto = 'REMISION';


      if(factura.codigo_postal==null){
          save=false;
          descripcion='El Cliente no tiene codigo postal ';
      }
      if(factura.regimen==null){
          save=false;
          descripcion='El Cliente no tiene Regimen Fiscal';
      }
      
      if(save){
        // console.log( 'state---->',this.state)
        this.props[action](factura, (data) => {
                
                if(data.estado){
                  self.props.alerta({
                    mensaje:"Factura Guardada Correctamente",
                    tipo:"success",
                    creacion:moment().format('Y-MM-DD H:m:s'),
                  });
                  self.props.history.push('/invoiceModule');

                }else{
                  swal("Oops..",data.mensaje);
                }
      });

      }else{
        swal("Oops..",descripcion);
      }
       }else{
          swal("Oops..", "Favor de Agregar Productos");
      }
    }

	render(){

		let {factura} = this.state;
		let {productos} = this.state;
    let {tickets} = this.state;
		let {folios} = this.state;
		let loading = false;
    console.log('productos factura---->',productos)
		return(
			<div className="view">
            	<Menu props={this.props}/>
                <div className="view-header">
                    <header className="title text-white">
                      <div className="row">
                        <div className="col">
                          <h1 className="h4 text-uppercase">Facturacion </h1>
                        </div>
                        <div className="col text-right">
                          <Button className="btn" onClick={ (button) => { this.props.history.push('/invoiceModule') } }  color="secondary"><FAchevronleft/> Atras</Button>
                          {' '}
                          <Button className="btn" onClick={ (button) => { this.toggle_modal(32,"Facturas","factura_imp") } }  color="primary"><IconPlus/> Factura</Button>
                          {' '}
                          <Button className="btn" onClick={ (button) => { this.toggle_modal(34,"Tickets","ticket_imp") } }  color="primary"><IconPlus/> ticket</Button>
                          {' '}
                          {//<Button className="btn" color="primary"><IconPlus/> cotizacion</Button>
                         }
                        </div>
                      </div>
                    </header>
                </div>
                <form onSubmit={this.submit} >
           		<div className="view-content view-components">
                    <Card>
                    	<CardBlock>
                        <div className="row">
                          <div className="col-12 col-sm-6 col-md-2"> 
                              <div className="">
                                <label className="">Cliente: </label><br/>
                                <div style={{display : 'flex'}}>
                                  <input
                                    placeholder=""
                                    type="text"
                                    name="cliente_id"
                                    value={factura.cliente_id}
                                    onChange={ this.handleInputChange}
                                    onBlur={this.handleClose}
                                    className="input_factura"
                                    required
                                  />
                                  <Button style={{height: '33px'}} onClick={ (button) => { this.toggle_modal(30,"Clientes","cliente_id") } } >...</Button>
                                 {/* <p className="ml-1">{factura.cliente_nombre}</p>*/}
                                </div>
                              </div>
                          </div>
                          <div className="col-12 col-sm-6 col-md-2">
                            <div className="form-group">
                              <label>Factura/Remision </label><br/>
                              {/*<select */}
                              <Input type="select" 
                                name="tipo_doc" 
                                id="exampleSelect" 
                                value={factura.tipo_doc} 
                                onChange={(e) => this.handleSelectChange(e,'tipo_doc')}
                                style={{width: '130px'}}
                                disabled={ parseInt( factura.id)>0 ?true:false}
                              >
                                <option value={1}>Factura</option>
                                <option value={2}>Remision</option>
                              </Input>
                              {/*</select>*/}
                            </div>
                          </div>
                          <div className="col-12 col-sm-6 col-md-2">
                          <div className="form-group">
                            <label className>Tipo:</label>
                            <Select
                              placeholder=""
                              type="text"
                              name="credito"
                              options={tipos_precios}
                              value={parseInt(factura.credito) || 0}
                              onChange={ (select) => { this.handleSelectChange(select, 'credito',1) } }
                              
                              clearable={false}
                            />
                          </div>
                        </div>
                          <div className="col-12 col-sm-6 col-md-2">
                            <div className="form-group">
                              <label>Moneda </label><br/>
                              {/*<select value={factura.moneda} onChange={(e) => this.handleSelectChange(e,'moneda')}>*/}
                              <Input type="select" 
                                name="moneda" 
                                id="exampleSelect" 
                                value={factura.moneda} 
                                onChange={(e) => this.handleSelectChange(e,'moneda')}
                                style={{width: '130px'}}
                              >
                                <option value={'MXN'}>Peso (MXN)</option>
                                <option value={'USD'}>Dolar (USD)</option>
                              </Input>
                              {/*</select>*/}
                            </div>
                          </div>
                          <div className="col-12 col-sm-6 col-md-2">
                              <div className="form-group">
                                <label className>Tipo de Venta:</label>
                                <Select
                                  placeholder=""
                                  type="text"
                                  name="tipo_venta"
                                  options={tipos_compra}
                                  value={parseInt(factura.tipo_venta) || 0}
                                  onChange={ (select) => { this.handleSelectChange(select, 'tipo_venta',1) } }
                                  
                                  clearable={false}
                                />
                              </div>
                          </div>
                          <div className="col-12 col-sm-6 col-md-2">
                            <div className="form-group">
                              <label>TC: $ {this.trunc( factura.tc,2)} </label>{'   '}
                               <Button
                                     color="success" 
                                     onClick={(evt)=>this.actualizar_tc(evt)}>
                                    <Refresh/>
                                    </Button>
                            </div>
                          </div>
                        </div>
                    		<div className="row mt-4">
                          <div className="col-8 div_titulo  ">
                            <h1><span>Datos Cliente</span></h1>
                            <div className="row">
                              <div className="col-6 ">
                                <div className="form-group">
                                  <label><b>Facturar a:</b> {factura.facturar_a}</label>
                                </div>
                              </div>
                              <div className="col-3 ">
                                <div className="form-group">
                                  <label><b>rfc: </b>{factura.rfc}</label>
                                </div>
                              </div>
                              <div className="col-3 ">
                                <div className="form-group">
                                  <label><b>Regimen Fiscal:</b> {factura.regimen}</label>
                                </div>
                              </div>
                              <div className="col-3 ">
                                <div className="form-group">
                                  <label><b>Residencia F.:</b> {factura.recidencia_fiscal}</label>
                                </div>
                              </div>
                              <div className="col-3 ">
                                <div className="form-group">
                                  <label><b>Registro de I. Fiscal:</b> {factura.registro_fiscal}</label>
                                </div>
                              </div>
                              <div className="col-md-3 ">
                                <div className="form-group">
                                  <label><b>SALDO:</b> </label>
                                  <label className='ml-2'>{factura.saldo_cliente}</label>
                                </div>
                              </div>
                              <div className="col-md-3 ">
                                <div className="form-group">
                                  <label><b> Credito Dis.: </b></label>
                                  <label className='ml-2'>{factura.credito_disponible}</label>
                                </div>
                              </div>
                              <div className="col-9 ">
                                <div className="form-group">
                                  <label><b>Dirección:</b> {factura.direccion}</label>
                                </div>
                              </div>
                              <div className="col-md-3 ">
                                <div className="form-group">
                                  <label><b>CP:</b> </label>
                                  <label className='ml-2'>{factura.codigo_postal}</label>
                                </div>
                              </div>
                            </div>
                          </div>
		                   		<div className="col-3 div_titulo ml-4">
                            <h1><span>Condiciones</span></h1>
                            <div className="row">
                              <div className="col-6">
                                <div className="form-group">
                                  <label>Terminos: </label><br/>
                                  <input
                                        placeholder=""
                                        type="text"
                                        name="term_pago"
                                        value={parseInt(factura.term_pago)==0?'':factura.term_pago}
                                        onChange={ this.handleInputChange}
                                        onBlur={this.handleClose}
                                        className="input_factura"
                                        />
                                  
                                 </div>
                              </div>
                              <div className="col-6">
                                <div className="form-group">
                                    <label>Plazo/P: </label><br/>
                                    <input
                                      placeholder=""
                                      type="number"
                                      name="plazo_p"
                                      value={factura.plazo_p}
                                      onChange={this.handleInputChange}
                                      className="input_factura"
                                    />
                                  </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col">
                                <Label className="ml-4">{factura.term_pago_nombre}</Label>
                              </div>
                            </div>
                          </div>
	                   		</div>
                        <div className="row mt-4">
                          <div className="col-12 div_titulo">
                            <h1><span>Datos Fiscales</span></h1>
                            <div className="row">
                              <div className="col-md-3"> 
                                <div className="form-group">
                                  <label className>Forma de Pago:</label>
                                  <Select
                                    placeholder=""
                                    type="text"
                                    name="formas_pago_codigo"
                                    options={this.state.formas}
                                    value={factura.formas_pago_codigo || ""}
                                    onChange={ (select) => { this.handleSelectChange(select, 'formas_pago_codigo',1) } }
                                    clearable={false}
                                    required
                                  />
                                </div>
                              </div>
                              <div className="col-md-3"> 
                                <div className="form-group">
                                    <label className>Metodo de Pago:</label>
                                    <Select
                                        placeholder=""
                                        type="text"
                                        name="metodo_pago_codigo"
                                        options={this.state.metodos}
                                        value={factura.metodo_pago_codigo || ""}
                                        onChange={ (select) => { this.handleSelectChange(select, 'metodo_pago_codigo',1) } }
                                        clearable={false}
                                        required

                                    />
                                </div>
                            </div>
                            <div className="col-md-6"> 
                                <div className="form-group">
                                    <label className>Uso del CFDI:</label>
                                    <Select
                                        placeholder=""
                                        type="text"
                                        name="uso_cfdi"
                                        options={this.state.usos}
                                        value={factura.uso_cfdi || ""}
                                        onChange={ (select) => { this.handleSelectChange(select, 'uso_cfdi',1) } }
                                        clearable={false}
                                        required

                                    />
                                </div>
                            </div>
                            </div>
                          </div>
                        </div>


                        <div className="row mt-4">
                          <div className="col-4 div_titulo">
                            <h1><span>Vendedor</span></h1>
                            <div className="row">
                              <div className="col-8"> 
                                <div className="form-group">
                                    <label className="-block">Vendedor:</label><br/>
                                    <input
                                    placeholder=""
                                    type="text"
                                    name="vendedor_id"
                                    value={factura.vendedor_id}
                                    onChange={ this.handleInputChange}
                                    onBlur={this.handleClose}
                                    className="input_factura"
                                    required
                                    />
                                    <Button onClick={ (button) => { this.toggle_modal(31,"Vendedores","vendedor_id") } } >...</Button><br/>
                                    <label className="mt-2">
                                    {factura.vendedor_nombre}
                                  </label>
                                </div>
                              </div>
                              <div className="col-4">
                                <div className="form-group">
                                  <label>Comision: </label><br/>
                                  <input
                                    placeholder=""
                                    type="number"
                                    name="comision"
                                    value={factura.comision}
                                    onChange={this.handleInputChange}
                                    className="input_factura"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-4 div_titulo ml-4">
                            <h1><span>Factura Relacionada</span></h1>
                            <div className="row">

                                <div className="col-md-12"> 
                    <div className="form-group">
                        <label >Motivo *:</label>
                        <Select
                            placeholder=""
                            type="text"
                            name="relacion_motivo"
                            options={this.state.motivos}
                            value={factura.relacion_motivo}
                            onChange={ (select) => { this.handleSelectChange(select, 'relacion_motivo',1) } }
                            clearable={false}

                        />
                    </div>
                </div>
                                <div className="col-12 col-sm-6 col-md-12"> 
                              <div className="">
                                <label className="">Factura  </label><br/>
                                <div style={{display : 'flex'}}>
                                  <input
                                    placeholder=""
                                    type="text"
                                    name="folio_relacion"
                                    value={factura.folio_relacion}
                                    className="input_factura"
                                    style={{width: '80%', 'marginBottom': '12px'}}
                                    readOnly
                                    required

                                  />
                                  <Button style={{height: '33px'}} onClick={ (button) => { this.toggle_modal(36,"Facturas","folio_relacion") } } >...</Button>
                                 {/* <p className="ml-1">{factura.cliente_nombre}</p>*/}
                                </div>
                              </div>
                          </div>
                              <div className="col-md-4 d-none"> 
                                <div className="form-group">
                                  <label className="">Via Emb:</label><br/>
                                  <input
                                  placeholder=""
                                  type="text"
                                  name="embarque_id"
                                  value={parseInt(factura.embarque_id)==0?'':factura.embarque_id}
                                  onChange={ this.handleInputChange}
                                  onBlur={this.handleClose}
                                  className="input_factura"
                                  />
                                  <Button onClick={ (button) => { this.toggle_modal(21,"Embarques","embarque_nombre") } } >...</Button>
                                  <label className="mt-2">
                                    {factura.embarque_nombre}
                                  </label>
                                </div>
                              </div>
                              <div className="col-md-4 d-none">
                                <div className="form-group">
                                  <label># Guia: </label><br/>
                                  <input
                                    placeholder=""
                                    type="text"
                                    name="no_guia"
                                    value={factura.no_guia}
                                    onChange={this.handleInputChange}
                                    className="input_factura_number"
                                  />
                                </div>
                              </div>
                              <div className="col-md-4 d-none"> 
                                <div className="form-group">
                                    <label className="">Codigo Lab:</label><br/>
                                    <input
                                      placeholder=""
                                      type="text"
                                      name="lab_codigo"
                                      value={factura.lab_codigo}
                                      onChange={ this.handleInputChange}
                                      onBlur={this.handleClose}
                                      className="input_factura"
                                      />
                                    <Button onClick={ (button) => { this.toggle_modal(22,"Lab","lab_id") } } >...</Button><br/>
                                    <label className="mt-2">
                                      {factura.lab_nombre}
                                    </label>
                                  </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-3">
                            <div className="row">
                              <div className="col-12"> 
                                <div className="form-group">
                                    <label className="-block">Almacen:</label><br/>
                                    <input
                                      placeholder=""
                                      type="text"
                                      name="almacen_codigo"
                                      value={factura.almacen_codigo}
                                      onChange={ this.handleInputChange}
                                      onBlur={this.handleClose}
                                      className="input_factura"
                                      required
                                    />
                                    <Button onClick={ (button) => { this.toggle_modal(25,"Almacenes","almacen_codigo") } } >...</Button>
                                    <label className="mt-2  ml-3">
                                      {factura.almacen_nombre}
                                    </label>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6 mt-3">
                                <div className="form-group">
                                  <label className>Notas</label>
                                  <Input
                                  rows={3}                            
                                  type="textarea"
                                  name="notasHeader"
                                  value={factura.notasHeader} 
                                  onChange={ this.handleInputChange }
                                  />
                                </div>
                          </div>
                        
                        <div className="col-md-6 mt-3"> 
                            <ReactTable
                              data      = {this.state.tickets}
                              className = "-striped -highlight"
                              columns   = {[
                                {
                                    Header: 'Controles',
                                    filterable: false,
                                    sortable: false,
                                    maxWidth:100,minWidth:100,
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-right">
                                                <Button
                                                 color="danger" 
                                                 onClick={(evt)=>this.delete_ticket(evt, row.original)}>
                                                    X
                                                </Button> 
                                            </div>
                                        )
                                    }
                                },
                                {Header: 'Ticket', accessor: 'clave'},
                              ]}
                              filterable 
                             pageSizeOptions= {[3]}  defaultPageSize={3} 
                               defaultFilterMethod={filterCaseInsensitive}
                            />        
                        </div>
                

                        </div>
                    	</CardBlock>
                    	<CardBlock>
                    		<div className='row'>
                    			<div className="col text-right" >
                    				<Button color="success" className="mb-2" onClick={this.toggleProducto}>
                                {<IconList/>}&nbsp;Agregar Producto
                            </Button>
		                            {' '}
                            <Button color="primary" className="mb-2" type="submit">
                              {<IconList/>}&nbsp;Guardar
                            </Button>
                                {' '}
                    			</div>
                    		</div>
                    		<div className="row">
                    			<div className="col-12">
                    			<ReactTable
                              	getTrProps={(state, rowInfo, column) => {
                                  
                                  if(rowInfo === undefined){
                                          
                                          return{

                                          }
                                        }else{
                                           return{
                                            onDoubleClick: (evt)=>this.toggle(evt, rowInfo.original.value, 'Editar Inventario Fisico')
                                        } 
                                  
                                    }
                              }}
                             
                              className = "-striped -highlight"
                              columns   = {[
                               	{
                                    Header: 'Controles',
                                    filterable: false,
                                    sortable: false,
                                    maxWidth:150,
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-right">
                                            	<Button
	                                             color="success" 
	                                             className="btn-sm" 
	                                             onClick={(evt)=>this.toggleProducto (evt, row.original.item_id,row.index,row.original)}>
	                                                <IconEdit />
	                                            </Button>
                                              {'  '}
                                                <Button
                                                  color="danger"
                                                  className="btn-sm"
                                                  onClick={(evt)=>this.delete(evt, row.index)}
                                                >{'X'}
                                                </Button>
                                                 
                                            </div>
                                        )
                                    }
                                },
                                // {Header: 'Ticket_id', accessor: 'ticket_id',maxWidth:150, minWidth:150 },
                                {Header: 'Ticket', accessor: 'clave_ticket',maxWidth:150, minWidth:150 },
                                {Header: 'Codigo', accessor: 'codigo_item',maxWidth:150, minWidth:150 },
                                {Header: 'Descripcion', accessor: 'descripcion_item',maxWidth:300, minWidth:300},
                                {Header: 'unidad', accessor: 'unidad_sat_codigo',maxWidth:150, minWidth:150},
                                {Header: 'Cant.', accessor: 'cantidad' , filterable: false, maxWidth:150, minWidth:150},
                                {Header: 'precio', accessor: 'precio' , filterable: false, maxWidth:150, minWidth:150,style: { textAlign: 'center'},Cell: props => <div> {this.formateo(props.value)} </div>},
                                {Header: 'importe', accessor: 'importe',filterable: false, maxWidth:150, minWidth:150,style: { textAlign: 'center'},Cell: props => <div> {this.formateo(props.value)} </div>},
                                {Header: '% descuento', accessor: 'descuento_porc',filterable: false, maxWidth:150, minWidth:150},                                
                                {Header: 'imp 1', accessor: 'impuesto1',filterable: false, maxWidth:150, minWidth:150,style: { textAlign: 'center'},Cell: props => <div> {this.formateo(props.value)} </div>},
                                {Header: 'imp 2', accessor: 'impuesto2',filterable: false, maxWidth:150, minWidth:150,style: { textAlign: 'center'},Cell: props => <div> {this.formateo(props.value)} </div>},
                                {Header: 'ieps', accessor: 'ieps_venta',filterable: false, maxWidth:150, minWidth:150,style: { textAlign: 'center'},Cell: props => <div> {this.formateo(props.value)} </div>},
                                {Header: 'total', accessor: 'total',filterable: false, maxWidth:150, minWidth:150,style: { textAlign: 'center'},Cell: props => <div> {this.formateo(props.value)} </div>},
                              ]}
                            
                              //manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                              data={productos}
                              //pages={pages} // Display the total number of pages
                              loading={loading} // Display the loading overlay when we need it
                              //onFetchData={_.debounce(this.fetchData, 500)} // Request new data when things change
                              filterable
                              defaultPageSize={10} 
                              defaultFilterMethod={filterCaseInsensitive}
                             
                            />
                            </div>
                    		</div>
                    	</CardBlock>
                      <CardBlock>
                        <div className="row justify-content-end">
                          <div className="col-3">
                            <div className="row">
                              <div className="col">
                                <Label>Importe:</Label><Label className="ml-4 float-right">{this.formateo(factura.importe)}</Label>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col">
                                <Label>Descuento:</Label><Label className="ml-4 float-right">{this.formateo(factura.descuentos)}</Label>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col">
                                <Label>Subtotal:</Label><Label className="ml-4 float-right">{this.formateo(factura.subtotal)}</Label>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col">
                                <Label>Ieps:</Label><Label className="ml-4 float-right">{this.formateo(factura.ieps)}</Label>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col">
                                <Label>impuestos:</Label><Label className="ml-4 float-right">{this.formateo(factura.impuestos)}</Label>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col">
                                <Label>Total:</Label><Label className="ml-4 float-right">{this.formateo(factura.total)}</Label>
                              </div>
                            </div>

                          </div>
                        </div>
                      </CardBlock>
                    </Card>
                </div>
                </form >
                { this.state.modal&&
	                <ModalTablas
	                    open={this.state.modal}
	                    toggle={this.toggle_modal}                  
	                    titulo={this.state.titulo}
	                    catalogo={this.state.tabla_modal}
	                    retorno={this.retorno}
	                    campo={this.state.campo_modal}
                        
                      cliente_id={0}
	                />
	            }
	            {
                   this.state.modalProducto&& 
                 <FacturaModal 
                 open={this.state.modalProducto} 
                 toggle={this.toggleProducto} 
                 title={this.state.title} 

                 prospectoid={this.state.prospectoid}
                 indiceproducto={this.state.indiceproducto}
                 producto_renglon={this.state.producto_renglon}

                 Almacen={this.state.factura.almacen_id}
                 tc={this.state.factura.tc}
                 descuento={this.state.factura.descuento}
                 codigo_precio={this.state.factura.codigo_precio}
                 moneda={this.state.factura.moneda}
                 retorno={this.retornoProducto}
                 codigo_comision={this.state.factura.codigo_comision}
                 documento={factura.tipo_doc}
                />
                }
            </div>
		)
	}
}

function mapStateToProps(state, ownProps) {
    return {
        factura : state.factura,
        notificciones:state.notificciones,
        auth:state.auth,
    }
};
export default connect(mapStateToProps, actions)(InvoiceModuleForm)


// WEBPACK FOOTER //
// ./src/views/facturacion/invoiceModule/invoiceForm.js